import React, { useRef, useState } from 'react';
import { useOnClickOutside } from '../hooks';
import useBindActionCreators from '../hooks/useBindActionCreators';
import { setIsOpenContactDropdown } from '../store/slices/contactDropdownSlice';
import useStore from '../store/selectors/useStore';
import BurgerButton from './BurgerButton';
import ContactButton from './ContactButton';
import ContactDropdown from './ContactDropdown';

interface propContact {
	className?: string;
}

function Contact({ className }: propContact) {
	const { contactDropdown } = useStore();
	const boundCreators = useBindActionCreators({
		setIsOpenContactDropdown,
	});
	const { setIsOpenContactDropdown: dispatchIsOpenContactDropdown } =
		boundCreators;

	const refConctactDropdown = useRef<HTMLDivElement>(null);

	const handleOpenDropdown = () => {
		dispatchIsOpenContactDropdown(true);
	};

	const handleCloseDropdown = () => {
		dispatchIsOpenContactDropdown(false);
	};

	useOnClickOutside(refConctactDropdown, handleCloseDropdown);

	return (
		<div ref={refConctactDropdown} className={`contact ${className}`}>
			<div className="contact__body">
				<ContactButton
					className="contact__button"
					openDropdown={handleOpenDropdown}
				/>
				<BurgerButton
					className="contact__burger-button"
					openDropdown={handleOpenDropdown}
					closeDropdown={handleCloseDropdown}
					isOpenDropdown={contactDropdown}
					refConctactDropdown={refConctactDropdown}
				/>
				<ContactDropdown
					className="contact__dropdown"
					isOpenDropdown={contactDropdown}
					closeDropdown={handleCloseDropdown}
				/>
			</div>
		</div>
	);
}

export default Contact;
